import { render, staticRenderFns } from "./addLgota.vue?vue&type=template&id=3b750ddc"
import script from "./addLgota.vue?vue&type=script&lang=js"
export * from "./addLgota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports